import React from 'react';

import { ImageProp } from './listing-tile-thumbnail';
import { qaAttribute } from '../utils/qa-service';

import {
    H2,
    ImageBadge,
    ImageBadgeWrapper,
    JobsAttributes,
    JobsFooterWrapper,
    JobsLargeLogo,
    JobsSmallLogo,
    PriceStyle,
    TimeWrapperStyle,
} from './listing-tile.style';
import { LocationAtMiddleWrapper } from './location-wrapper/location-at-middle-wrapper';
import { InfoWrapper } from './info-wrapper/info-wrapper';
import { TileHeaderWrapper } from './title-row-wrapper/title-row-wrapper';

export interface Props {
    title: string;
    isGridViewOnDesktop?: boolean;
    favouriteToggle: React.ReactElement | undefined;
    location: string;
    timeSincePosted?: string;
    urgent: boolean;
    featured: boolean;
    attributesOrDescription: {
        isAttributes: boolean,
        render: () => React.ReactElement | undefined,
    };
    image: ImageProp;
    salary: string;
}

const TileInfoJobs = ({
    isGridViewOnDesktop,
    title,
    favouriteToggle,
    location,
    timeSincePosted = '',
    urgent,
    featured,
    attributesOrDescription,
    image,
    salary,
}: Props) => {
    const isLogo = Boolean(image.src);

    return (
        <>
            <TileHeaderWrapper>
                <div>
                    <ImageBadgeWrapper>
                        {featured && (
                            <ImageBadge isFeatured isJobsCategory>
                                Featured
                            </ImageBadge>
                        )}
                        {urgent && (
                            <ImageBadge isUrgent isJobsCategory>
                                Urgent
                            </ImageBadge>
                        )}
                    </ImageBadgeWrapper>

                    <H2 {...qaAttribute('tile-title')} isGridView={isGridViewOnDesktop}>
                        {title}
                    </H2>
                </div>

                {favouriteToggle}
            </TileHeaderWrapper>

            <JobsAttributes>
                <div>
                    <LocationAtMiddleWrapper
                        {...qaAttribute('tile-location')}
                        isGridView={isGridViewOnDesktop}
                        isJobsCategory
                    >
                        {location}
                    </LocationAtMiddleWrapper>
                    {attributesOrDescription.render()}
                </div>
                {isLogo && (
                    <JobsLargeLogo
                        {...qaAttribute('tile-large-logo')}
                        src={image.src}
                        alt={image.alt}
                    />
                )}
            </JobsAttributes>

            <InfoWrapper isJobsCategory>
                <JobsFooterWrapper>
                    <div css={PriceStyle} data-testid="price">
                        {salary}
                    </div>
                    {isLogo && (
                        <JobsSmallLogo
                            {...qaAttribute('tile-small-logo')}
                            src={image.src}
                            alt={image.alt}
                        />
                    )}
                </JobsFooterWrapper>
                <div {...qaAttribute('tile-posted-date')} css={TimeWrapperStyle}>
                    {timeSincePosted}
                </div>
            </InfoWrapper>
        </>
    );
};

export default TileInfoJobs;
